export default __webpack_public_path__ + "static/media/animation-red.345119eb.gif";